export const dataFocusVisibleClasses = [
  'focus:outline-none',
  'web:data-[focus-visible=true]:outline-layout-focus',
  'web:data-[focus-visible=true]:outline',
  'web:data-[focus-visible=true]:outline-4',
  'web:data-[focus-visible=true]:outline-offset-1',
]
